// Soil-temperature phase tokens + phase→tool routing.
//
// Note: the old `RecommendationCard` component that lived here was dead code —
// the verdict hero in page-content.tsx inlines its own markup off these same
// tokens. Only `STATUS_STYLES` and `getToolForPhase` are consumed, so the
// component was removed to kill the duplicated markup. This module is the
// single source of truth for the four soil-temp phase statuses.

export interface PhaseTool {
  href: string
  label: string
}

export function getToolForPhase(title: string): PhaseTool | null {
  const t = title.toLowerCase()
  if (t.includes("pre-emergent") || t.includes("pre emergent")) {
    return { href: "/tools/herbicide-timing", label: "Plan your herbicide timing" }
  }
  if (t.includes("overseed") || t.includes("seed")) {
    return { href: "/tools/seeding-calculator", label: "Calculate how much seed you need" }
  }
  if (
    t.includes("peak root growth") ||
    t.includes("active growth") ||
    t.includes("optimal growth") ||
    t.includes("green-up")
  ) {
    return { href: "/tools/fertilizer-calculator", label: "Calculate your fertilizer rate" }
  }
  if (t.includes("heat") || t.includes("summer dormancy")) {
    return { href: "/tools/watering-schedule", label: "Build a watering schedule" }
  }
  return null
}

export const STATUS_STYLES = {
  dormant: {
    bg: "bg-gray-50",
    border: "border-gray-200",
    badge: "bg-gray-100 text-gray-700",
    icon: "text-gray-400",
    text: "text-gray-700",
  },
  caution: {
    bg: "bg-amber-50",
    border: "border-amber-200",
    badge: "bg-amber-100 text-amber-700",
    icon: "text-amber-500",
    text: "text-amber-700",
  },
  optimal: {
    bg: "bg-green-50",
    border: "border-green-200",
    badge: "bg-green-100 text-green-700",
    icon: "text-green-500",
    text: "text-green-700",
  },
  warning: {
    bg: "bg-red-50",
    border: "border-red-200",
    badge: "bg-red-100 text-red-700",
    icon: "text-red-500",
    text: "text-red-700",
  },
}
